<template>
  <div class="videoContainer">
    <button v-show="!loaded" @click="handleClick" class="playButton icon-play" />
    <img @load="posterLoaded" :src="thumbnailUrl" class="hide" />
    <video v-show="imgLoaded" ref="videoElem" preload="none" :poster="thumbnailUrl" playsinline></video>
  </div>
</template>

<script>
import Hls from "hls.js";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      thumbnailUrl: `https://image.mux.com/${
        this.options.ASSET_ID
      }/thumbnail.png?width=580&height=320&fit_mode=smartcrop${
        this.options.THUMB_TIME ? "&time=" + this.options.THUMB_TIME : ""
      }`,
      hls: null,
      imgLoaded: false,
      loading: false,
      loaded: false,
    };
  },
  methods: {
    posterLoaded,
    loadVideo,
    setupEventListeners,
    handleClick() {
      if (!this.loaded) {
        this.loadVideo();
        this.setupEventListeners();
      }
    },
  },
  mounted() {
    if (this.$utils.isMobile()) {
      this.loaded = true;
      const video = this.$refs.videoElem;
      video.controls = true;
      var videoSrc = `https://stream.mux.com/${this.options.ASSET_ID}.m3u8`;
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(videoSrc);
        this.hls.attachMedia(video);
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = videoSrc;
      }
    }
  },
  beforeDestroy() {},
};

function posterLoaded() {
  this.imgLoaded = true;
}

function loadVideo() {
  this.loading = true;
  const video = this.$refs.videoElem;
  var videoSrc = `https://stream.mux.com/${this.options.ASSET_ID}.m3u8`;
  if (Hls.isSupported()) {
    this.hls = new Hls();
    this.hls.loadSource(videoSrc);
    this.hls.attachMedia(video);
    this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
      video.play();
      video.controls = true;
      this.loaded = true;
    });
  } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
    video.src = videoSrc;
    video.addEventListener("loadedmetadata", () => {
      video.play();
      video.controls = true;
      this.loaded = true;
    });
  }
}
function setupEventListeners() {
  this.$refs.videoElem.addEventListener("play", () => {
    document.querySelectorAll("video").forEach((video) => {
      video !== this.$refs.videoElem && video.pause();
    });
  });
}
</script>

<style lang="scss" scoped>
.videoContainer {
  position: relative;
  .playButton {
    cursor: pointer;
    position: absolute;
    border: none;
    top: 50%;
    left: 50%;
    width: 35%;
    height: 55%;
    margin-left: -17.5%;
    margin-top: -17.5%;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
    z-index: 9;
  }
  video {
    width: 100% !important;
    height: auto !important;
  }
}
</style>
